import { Box, Heading } from '@chakra-ui/react';
import { RoutePath } from 'router/routes.paths';
import Loader from 'common/components/Loader';
import { useGetChampionnatList } from 'features/championnats/championnat.api';
import ChampionnatList from 'features/championnats/components/ChampionnatList';
import BPCPageHeading from 'common/components/BPCPageHeading';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useConnectedUserContext } from 'features/user/useConnectedUserContext';
import { useGetChampionnatsPersonnalises } from 'features/championnats/championnat.api';
import ChampionnatPersonnaliseList from 'features/championnats/components/ChampionnatPersonnaliseList';

export default function ChampionnatsListPage() {
  const { championnats, isLoading } = useGetChampionnatList();
  const { user } = useConnectedUserContext();
  const {
    championnats: championnatsPersonnalises,
    isLoading: isLoadingPersonnalises,
  } = useGetChampionnatsPersonnalises(user?.id);
  const navigate = useNavigate();

  if (isLoading || isLoadingPersonnalises || !championnats) {
    return <Loader fullScreen />;
  }

  return (
    <Box>
      <BPCPageHeading
        helmetName="Championnats"
        title="Liste des championnats"
        breadcrumbItems={[{ to: RoutePath.home, name: 'Home' }]}
        buttonProps={[
          {
            title: 'Créer un championnat',
            leftIcon: <FaPlus />,
            onClick: () => navigate(RoutePath.championnatNew),
          },
        ]}
      />

      <ChampionnatList flexWrap="wrap" championnats={championnats} />
      {championnatsPersonnalises.length > 0 && (
        <Box mt={10}>
          <Heading mb={2} size="md" textTransform="uppercase">
            Mes championnats personnalisés
          </Heading>
          <ChampionnatPersonnaliseList
            flexWrap="wrap"
            championnats={championnatsPersonnalises}
          />
        </Box>
      )}
    </Box>
  );
}
